import { render } from "./Manage.vue?vue&type=template&id=1fe54786"
import script from "./Manage.vue?vue&type=script&lang=js"
export * from "./Manage.vue?vue&type=script&lang=js"

import "./Manage.vue?vue&type=style&index=0&id=1fe54786&lang=scss"
script.render = render

export default script